import { NgTemplateOutlet } from "@angular/common";
import { Component, Input } from "@angular/core";
import { ForgeCardModule, ForgeExpansionPanelModule, ForgeListItemModule, ForgeListModule, ForgeOpenIconModule } from "@tylertech/forge-angular";
import { ICardListGridViewMetadata } from "@tylertech/tyler-api-types";
import { RepositoryFormData } from "../../../interfaces";
import { OrderByPipe } from "../../../pipes/orderBy.pipe";
import { CardGroup } from "./cardList.component";
import { CardListItemBodyComponent } from "./cardListItemBody.component";
import { CardListItemHeaderComponent } from "./cardListItemHeader.component";

@Component({
    selector: "card-list-group",
    templateUrl: "./cardListGroup.tmpl.html",
    imports: [
        CardListItemBodyComponent,
        CardListItemHeaderComponent,
        ForgeCardModule,
        ForgeExpansionPanelModule,
        ForgeListItemModule,
        ForgeListModule,
        ForgeOpenIconModule,
        NgTemplateOutlet,
        OrderByPipe,
    ]
})
export class CardListGroupComponent
{
    @Input()
    view: ICardListGridViewMetadata;

    @Input()
    groups: CardGroup[];

    @Input()
    datacontroller: RepositoryFormData;

    @Input()
    hasBody: boolean;

    @Input()
    readonly depth: number = 0;

    isOpen(group: CardGroup): boolean
    {
        return group.Open;
    }

    toggle($event, group: CardGroup): void
    {
        if (this.hasOpenChild($event, group) && $event.currentTarget.open)
            group.Open = true;
        else
            group.Open = !group.Open;
        if (group.Entities)
            group.Entities.forEach(e => e["$cardVisible"] = group.Open);
    }

    hasOpenChild($event, group: CardGroup): boolean
    {
        if (!group.Groups)
            return $event.currentTarget.open;
        let hasOpen = false;
        group.Groups.forEach(g =>
        {
            if (this.hasOpenChild($event, g))
                hasOpen = true;
        });
        return hasOpen;
    }
}
